// Scrollmenu
// Change active menu item on scroll

$(window).on('load', scrollMenu);
$(window).on('scroll', scrollMenu);

function scrollMenu() {

    $('.header-section a[data-scroll-link]').on('click', function () {
        closeMenu();
    });

    // todo: maybe set active class like spyscroll

    return false;
}
